module.exports = __webpack_public_path__ + "img/file.b5aa11b1.svg";